import { AssetSvgProps } from "../../../shared/assets"

export const defaultColors = {
    "col1n": "#434343"
}

function HaiHig009({ colors = defaultColors, className, onClick, outerTransform, transform, startDrag }: AssetSvgProps) {
    return (
        <g transform={outerTransform}><g className={className} onClick={onClick} transform={transform} onMouseDown={startDrag} onTouchStart={startDrag}><defs>
                <path
                    fill={colors.col1n}
                    d="M6.5 135.5Q5.65 53.45 20.65 0-11.6 24.8 6.5 135.5z"
                    id="HaiHig009__Symbol_13_0_Layer0_0_FILL"
                />
            </defs>
            <use
                xlinkHref="#HaiHig009__Symbol_13_0_Layer0_0_FILL"
                transform="translate(121.65 77.85)"
                id="HaiHig009__col1n"
            />
        </g></g>
    )
}

export default HaiHig009
